import React from 'react';
// import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react"
import { Data, GoogleMap, InfoWindow, LoadScript, MapContext, Marker } from "@react-google-maps/api";


import DeviceList from './deviceList';
import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  FormGroup,
  Form,
  Button,
  UncontrolledTooltip,
  CardSubtitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert

} from "reactstrap"

import { connect } from "react-redux";
import ReactBSAlert from "react-bootstrap-sweetalert";
import MapComponent from './AddDeviceMaps';
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { useEffect } from 'react';
import { useState, createContext } from 'react';

import { LatitudeContext } from './MapContext';
import DeviceMapContainer from "./DeviceMapContainer";

import { AvForm, AvField } from "availity-reactstrap-validation";
import { apiEndpoint } from "helpers/url_helper";

//import apiURL from 'urlConfig';

//export const LatLongContext = createContext("67");


function AddDevice(props) {

  var EncodedCampus = '';
  var CampusImagePath = '';
  const [toggleSwitch, settoggleSwitch] = useState(true);
  const [toggleSwitchSize, settoggleSwitchSize] = useState(true);
  const [values, setValues] = useState([]);
  const [FormValues, setFormValues] = useState({ CampusID: '', CampusName: '', LocationName: '', ControllerIPAddress: '', CameraIPAddress: '', MacAddress: '' });
  const [modal_small, setmodal_small] = useState(false);


  const [NewLocationValue, setNewLocationValue] = useState();
  const [NewControllerIPValue, setNewControllerIPValue] = useState();
  const [NewRadarIPValue, setNewRadarIPValue] = useState();

  const [NewCameraIPValue, setNewCameraIPValue] = useState();
  const [NewMacAddressValue, setNewMacAddressValue] = useState();
  const [NewLatitudeValue, setNewLatitudeValue] = useState(18.6483);
  const [NewLongitudeValue, setNewLongitudeValue] = useState(73.7990);
  const [NewCampusID, setNewCampusID] = useState(2);
  const [CampusImageFile, setCampusImageFile] = useState();
  const [EncodedCampusImage, setEncodedCampusImage] = useState(' ');
  const [AddCampusResponse, setAddCampusResponse] = useState(null);
  const [AddCampusResponseType,setAddCampusResponseType]= useState(null);
  const [basic, setbasic] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [CampsuList, setCampusList] = useState([]);
  const [SelectedCampusValue, setSelectedCampusValue] = useState(1);

  const [AddNewCampusValue, setAddNewCampusValue] = useState();
  const [LatLong, setLatLong] = useState([NewLatitudeValue, NewLongitudeValue]);
  //const LatContextValue = {NewLatitudeValue, setNewLatitudeValue}; 

  const [hasError, setHasError] = useState(false);


  const containerStyle = {
    width: "150%",
    height: "100%",
}
var center = {
  lat:NewLatitudeValue,
  lng:NewLongitudeValue,
}
const mapClicked = (event) => {
  debugger;
  center = {lat: event.latLng.lat(), lng:event.latLng.lng()};

  // console.log(NewLatitudeValue);
  //setNewLatitudeValue(event.latLng.lat().toFixed(4));
  //setNewLongitudeValue(event.latLng.lng().toFixed(4));
    setNewLatitudeValue(event.latLng.lat());
    setNewLongitudeValue(event.latLng.lng());
 
}








  const tog_small = () => {
    debugger;
    setmodal_small(!modal_small)
    document.body.classList.add("no_padding")
  }


  useEffect(() => {

    debugger;
    // UserValidated
    fetch(apiEndpoint+"/CampusList",
      {
       method:"POST",
        headers: {
          'Content-Type': 'application/json',
         // 'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "strToken": sessionStorage.getItem("Clear_AuthUser")
          
        })
      })
      .then(res => res.json())
      .then((data) => {
        debugger;
        setCampusList(data.CampusList);
        setNewCampusID(data.CampusList[0].CampusID);
        //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))




      });

      
    

  }, []);

  const getCampusLiist = () =>
  {
    debugger;
    // UserValidated
    fetch(apiEndpoint+"/CampusList",
      {
        method:"POST",
        headers: {
          'Content-Type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "strToken": sessionStorage.getItem("Clear_AuthUser")
          
        })
      })
      .then(res => res.json())
      .then((data) => {
        debugger;
        setCampusList(data.CampusList);
        setNewCampusID(data.CampusList[0].CampusID);

        //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))

      });
  }


  const handleCampusChange = event => {
    debugger;


    setSelectedCampusValue(event.target.value);
    setNewCampusID(event.target.value);



  };
  
  const SubmitNewDeviceDetails = () => {
    debugger;
    // UserValidated
    fetch(apiEndpoint+'/AddNewDevice',
      {
        mode: "cors",
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "intCampusID": NewCampusID,
          "strLocationName": NewLocationValue,
          "strControllerIP": NewControllerIPValue,
          "strCameraIP": NewCameraIPValue,
          "strMacAddress": NewMacAddressValue,
          "strLatitude": NewLatitudeValue,
          "strLongitude": NewLongitudeValue,
          "strToken": sessionStorage.getItem("Clear_AuthUser")

        })


      }
    )
    .then(res => res.json())
    .then((data) => {
      //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))
      setAddCampusResponse(data.ResponseMessage);
      setAddCampusResponseType(data.ResponseType)
      if (data.ResponseType !="error") {
        setbasic(true);
        setModalOpen(false);
        setAddNewCampusValue(null);
        window.location.reload();


      }
      else  {
        setbasic(true);
      }
    });
  }



  const AddNewCampus = () => {
    debugger;
    // UserValidated
    fetch(apiEndpoint+'/AddNewcampus',
      {
        mode: "cors",
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "strCampusName": AddNewCampusValue,
          "strBase64CampusImage": EncodedCampus,
          "strCampusImagePath": CampusImagePath,
          "strToken": sessionStorage.getItem("Clear_AuthUser")

        })


      }
    )
      .then(res => res.json())
      .then((data) => {
        //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))
        setAddCampusResponse(data.ResponseMessage);
        setAddCampusResponseType(data.ResponseType)
        console.log(AddCampusResponseType)
        if (data.ResponseType !="error") {
        
          setbasic(true);
          setModalOpen(false);
          setAddNewCampusValue(null);
        

      }
        else {
          setbasic(true);
        }
      });


  }

  function validateIpAddress(value) {
    const ipAddressRegex =/^(\d+\.\d+\.\d+\.){1}\d+$/;
    if (!ipAddressRegex.test(value)) {
      return "Invalid IP address";
    }
    const ipAddressRegex1 = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    if (!ipAddressRegex1.test(value)) {
      return "Invalid IP address";
    }


    return true;
  }

  
function isValidLatitude(value) {
  const latRegex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;

  if(!latRegex.test(value))
  {
    return "Invalid Latitude Value";
  }
  else{
    return true;
  }
}

function isValidLongitude(value) {
  const lonRegex = /^[-+]?([1-9]?\d(\.\d+)?|1[0-7]\d(\.\d+)?|180(\.0+)?)$/;
  if(!lonRegex.test(value))
  {
    return "Invalide Longitude Value"
  }
  return true;
}





  return (


    <React.Fragment>


      {modalOpen ?
        <Modal
          isOpen={modal_small}

          toggle={() => {
            tog_small()

          }}

        >   
        <AvForm onValidSubmit={AddNewCampus}> 
          <ModalHeader>
            Add New Campus
            <div className="col-md-4">
              <input
                className="form-control"
                type="hidden"
              />
            </div>
          </ModalHeader>
          <ModalBody>
       
          <Row className="mb-3">
              <label
                htmlFor="example-email-input"
                className="col-md-4 col-form-label"
              >
                Campus Name
              </label>
              <div className="col-md-6">
                <AvField
                  className="form-control"
                  type="text"
                  name="Campus"
                  placeholder="Campus Name"

                  errorMessage="This text field is required"
                  validate={{
                    required: { value: true },
                    minLength: { value: 6, errorMessage: "Min 6 chars." },
                    pattern: { value: "/^[A-Za-z]+$/", errorMessage: "Only Alphabets Please ! " },
                    
                  }}
                  value={AddNewCampusValue}
                  onChange={(event) => {
                    setAddNewCampusValue(event.target.value);

                  }}

                />
              </div>
            </Row>
              
           

            {/* <Row className="mb-3">
              <label className="col-md-4 col-form-label">Campus Image</label>
              <div className="col-md-6">
                <input type="file"
                  className="form-control form-control-file "
                  data-buttonname="btn-secondary"
                  onChange={SelecCampusImage}
                  readOnly
                />

              </div>
            </Row> */}
          </ModalBody>
          <ModalFooter>
            <div className="col-md-4">
              <button className="btn btn-primary w-md" type="submit"
               id="sa-basic">Add Campus</button>
            </div>
          

          </ModalFooter>
         
</AvForm>
        </Modal>
        : ""}

      {basic ? (


        <ReactBSAlert  
        type={AddCampusResponseType}
                        //   style={bsAlertStyle}
                        title={AddCampusResponse}
                        onConfirm={() => {
                        
                          setbasic(false);
                          getCampusLiist();
                          console.log(AddCampusResponseType)
                        }}
                        confirmBtnBsStyle="info"
                        >                  
                        </ReactBSAlert>

      ) : null}



      <Row className="col-md-12">

        <Col className="col-md-12">
          <Card>
            <CardBody>

              
              <Row className="mb-3">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  Campus
                </label>

                <div className="col-md-4">
                  <select className="form-control" value={SelectedCampusValue} onChange={handleCampusChange} classNamePrefix="select2-selection"
                  >
                    {CampsuList.map(i => <option value={i.CampusID}>{i.CampusName}</option>
                    )}
                  </select>
                </div>
                <div className="col-md-2">
                  <Button
                    type="button"
                    color="primary"
                    className="waves-light waves-effect"
                    id="tooltip2"
                    onClick={() => {
                      tog_small();
                      setAddNewCampusValue(null);
                      setModalOpen(true);
                      EncodedCampus = null;
                    }}
                  >
                    <i className="fas fa-plus-circle" />
                  </Button>
                  <UncontrolledTooltip placement="right" target="tooltip2">
                    Click Here to Add New Campus
                  </UncontrolledTooltip>
                </div>

              </Row>



              <AvForm onValidSubmit={SubmitNewDeviceDetails}
              >
                <Row>
                  <div className="col-md-6 form-group">

                    <Row className="mb-3">
                      <label
                        htmlFor="example-search-input"
                        className="col-md-4 col-form-label"
                      >
                        Location
                      </label>
                      <div className="col-md-8 ">
                        <AvField
                          className="form-control"
                          type="text"
                          name="Location Name"
                          placeholder="Location Name"

                          errorMessage="This text field is required"
                          validate={{
                            required: { value: true },
                            minLength: { value: 6, errorMessage: "Min 6 chars." },
                            pattern: { value: "/^[A-Za-z0-9_-]+$/", errorMessage: "Only AlphaNumeric Values Please ! " },
                            
                          }}
                          value={NewLocationValue}
                          onChange={(event) => {
                            setNewLocationValue(event.target.value);
                          }}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="example-email-input"
                        className="col-md-4 col-form-label"
                      >
                        Controller IP
                      </label>
                      <div className="col-md-8">
                        <AvField
                          className="form-control"
                          type="text"
                          name="Controller IP"
                          placeholder="Controller IP Address"

                          errorMessage="This text field is required"
                          validate={{ custom: validateIpAddress }}

                          value={NewControllerIPValue}
                          onChange={(event) => {
                            setNewControllerIPValue(event.target.value);
                          }}

                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="example-email-input"
                        className="col-md-4 col-form-label"
                      >
                        Camera IP
                      </label>
                      <div className="col-md-8">
                        <AvField
                          className="form-control"
                          type="text"
                          name="Camera IP"
                          placeholder="Camera IP Address"
                          errorMessage="Camera IP Address is required"
                          validate={{
                            required: { value: true },
                            pattern: { value: "/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi", errorMessage: "Invalid IP Address" }
                          }}
                          defaultValue={NewCameraIPValue}
                          onChange={(event) => {
                            setNewCameraIPValue(event.target.value);
                          }}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="example-email-input"
                        className="col-md-4 col-form-label"
                      >
                        Radar IP
                      </label>
                      <div className="col-md-8">
                        <AvField
                          className="form-control"
                          type="text"
                          name="Radar IP"
                          placeholder="Radar IP Address"
                          errorMessage="Radar IP Address is required"
                          validate={{
                            required: { value: true },
                            pattern: { value: "/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi", errorMessage: "Invalid IP Address" }
                          }}
                          defaultValue={NewRadarIPValue}
                          onChange={(event) => {
                            setNewRadarIPValue(event.target.value);
                          }}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="example-email-input"
                        className="col-md-4 col-form-label"
                      >
                        MAC Address
                      </label>
                      <div className="col-md-8">
                        <AvField
                          className="form-control"
                          type="text"
                          name="Mac Address"
                          placeholder="MAC Address"
                          maxLength = "12"
                          errorMessage="This field is required 12 alphanumeric charecters"
                          validate={{
                            required: { value: true },
                            minLength: { value: 12, errorMessage: "Invalid MAC Address" },
                            pattern: { value: "[0-9a-f]{2}([-:]?)[0-9a-f]{2}(\\1[0-9a-f]{2}){4}$", errorMessage: "Invalid MAC Address" },
                          }}
                          defaultValue={NewMacAddressValue}
                          onChange={(event) => {
                            setNewMacAddressValue(event.target.value);
                          }}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="example-email-input"
                        className="col-md-4 col-form-label"
                      >
                        Latitude
                      </label>
                      <div className="col-md-8">
                        <AvField
                          className="form-control"
                          type="number"
                          name="Latitude"
                          placeholder="Latitude"

                          errorMessage="This text field is required"
                          validate={{ custom: isValidLatitude }}

                          value={NewLatitudeValue}
                          onChange={(event) => {
                            setNewLatitudeValue(event.target.value);
                          }}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="example-email-input"
                        className="col-md-4 col-form-label"
                      >
                        Longitude
                      </label>
                      <div className="col-md-8">
                        <AvField
                          className="form-control"
                          type="number"
                          name="Longitude"
                          placeholder="Longitude"

                          errorMessage="This text field is required"
                          validate={{ custom: isValidLongitude }}
                          value={NewLongitudeValue}
                          onChange={(event) => {
                            setNewLongitudeValue(event.target.value);

                          }}
                        />
                      </div>
                    </Row>
                  </div>

                  <div className="col-md-4">
       
                  </div>


                </Row>

                <Row>


                  <div class="col-md-6 offset-2">

                    <button type="submit" className="  btn btn-primary ">Submit</button>

                  </div>
                </Row>



              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>




    </React.Fragment>
  )
}

export default AddDevice;